import { render, staticRenderFns } from "./AssignManager.vue?vue&type=template&id=3adc9162&scoped=true"
import script from "./AssignManager.vue?vue&type=script&lang=js"
export * from "./AssignManager.vue?vue&type=script&lang=js"
import style0 from "./AssignManager.vue?vue&type=style&index=0&id=3adc9162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adc9162",
  null
  
)

export default component.exports